import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  titleBlue: {
    color: '#1671ED',
    cursor: 'move',
  },
  dialog: {
    // marginTop: '6%',
    maxheight: '900px',
    minHeight: '68%',
  },
  container: {
    display: 'flex',
    width: '800px',
    maxWidth: '800px',
    height: '100%',
    padding: '35px',
    flexDirection: 'column',
    borderTop: '2px solid #E3E3E3',
    overflowX: 'hidden',
  },
  dialogAction: {
    padding: '20px 30px',
  },
  scroll: {
    overflowY: 'auto',
    overflowX: 'hidden',
    margin: '0 8px 8px 0',

    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#E3E3E3',
      borderRadius: '20px',
      margin: '30px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'gray',
      borderRadius: '20px',
      border: '3px solid gray',
    },
  },
  button: {
    height: '40px',
    width: '140px',
    padding: '10px 16.5px',
  },
  labels: {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '20px',
    color: '#141414',
  },
  label: {
    fontSize: '16px',
    lineHeight: '20px',
    margin: '10px 0',
    color: '#B4B4B4',
  },
  textlabel: {
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '25px',
    color: '#696969',
  },
  inlineLabel: {
    display: 'flex',
    gap: '6px',
  },
  wrapper: {
    width: '100%',
    margin: '0px',
  },
  subjectWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
}))
